import React from "react";
import StyledInput from "./styled/input";
import { TextInputV2 } from "@boi/react-components";

const GLOBAL_ATTRS = [
    "className",
    "hidden",
    "id",
    "inputmode",
    "style",
    "tabIndex",
    "title",
    "size",
    "aria-label"
];
const EVENT_ATTRS = [
    "onBlur",
    "onClick",
    "onChange",
    "onError",
    "onFocus",
    "onInput",
    "onKeyPress",
    "onKeyUp",
    "onValid",
    "onPaste"
];
const INPUT_ATTRS = [
    "autoComplete",
    "autoFocus",
    "disabled",
    "form",
    "list",
    "name",
    "placeholder",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value",
    "step",
    "inputMode",
    "fieldWidth",
    "min"
]
    .concat(EVENT_ATTRS)
    .concat(GLOBAL_ATTRS);

const inputSafeProps = props => {
    return Object.keys(props).reduce((attrs, key) => {
        INPUT_ATTRS.includes(key) && (attrs[key] = props[key]);
        return attrs;
    }, {});
};

/* Remove innerRef prop, and add forwardRef to Input component 
if this file has been converted to typescript */
const Input = ({ cssClass = "", ...props }) => {
    cssClass.includes("readonly") && (props.readOnly = true);
    cssClass.includes("disabled") && (props.disabled = true);
    const accessibilitySettings = {};
    props.accessibilitySettings &&
        props.accessibilitySettings.forEach(setting => {
            if (setting.isShown)
                accessibilitySettings[setting.name] = setting.value || "";
        });

    return props.type !== "hidden" ? (
        <TextInputV2
            {...inputSafeProps(props)}
            onChange={newVal => {
                props.onChange({ target: { value: newVal }});
            }}
            onBlur={newVal => {
                props.onChange(newVal);
            }}
            {...accessibilitySettings}
        />) : (
        <StyledInput
            {...inputSafeProps(props)}
            ref={props.innerRef}
            {...accessibilitySettings}
        />
    );
};

Input.defaultProps = {
    cssClass: ""
};

export default Input;
export { inputSafeProps };
